import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { IMAGES } from "../lib/content";
import { useContent } from "../lib/ContentContext";

export default function RealityTeaser() {
  const { content } = useContent();
  const t = content.reality;
  return (
    <section data-testid="reality-teaser" className="relative overflow-hidden bg-[#0B0B0C] text-[#F1EDE6] scanlines">
      <div
        className="absolute inset-0 opacity-40"
        style={{ backgroundImage: `url(${IMAGES.fire})`, backgroundSize: "cover", backgroundPosition: "center", filter: "grayscale(0.4) contrast(1.1)" }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B0B0C] via-[#0B0B0C]/80 to-[#0B0B0C]/30" />
      <div className="grain-static" />
      <div className="absolute -right-16 -bottom-20 opacity-[0.07] pointer-events-none hidden lg:block">
        <Logo variant="light" size={420} testid="reality-teaser-mark" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-28 md:py-36 grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
        <div className="lg:col-span-8">
          <div className="inline-flex items-center gap-3 mono text-[10px] uppercase tracking-[0.3em] text-[color:var(--alta-red-soft)]">
            <span className="rec-dot" aria-hidden="true" />
            {t.teaser_eyebrow}
          </div>
          <h2 className="mt-6 condensed text-[60px] md:text-[104px] lg:text-[124px] whitespace-pre-line" data-testid="reality-teaser-title">
            {t.teaser_title}
          </h2>
          <p className="mt-8 text-[16px] md:text-[18px] leading-[1.75] text-[#F1EDE6]/70 font-light max-w-[58ch]">{t.teaser_body}</p>
        </div>
        <div className="lg:col-span-4 flex flex-col items-start lg:items-end gap-5">
          <Link to="/" data-testid="reality-teaser-cta" className="btn-red-primary group vlink">
            <span className="mr-3 border-y-[6px] border-y-transparent border-l-[10px] border-l-[#F1EDE6]" />
            <span>{t.teaser_cta}</span>
            <span className="ml-2 transition-transform duration-300 group-hover:translate-x-1">→</span>
          </Link>
          <span className="mono text-[10px] uppercase tracking-[0.26em] text-[#F1EDE6]/50">{t.teaser_note}</span>
        </div>
      </div>
      <div className="frame-mark tl" /><div className="frame-mark tr" />
      <div className="frame-mark bl" /><div className="frame-mark br" />
    </section>
  );
}
